import { ModerationQueue } from '../../components/reviews';
import { PageContainer } from '../../components/PageContainer';
export const AdminModeration = () => {
  return (
    <div className="px-0 md:px-4 pt-2 pb-4 max-w-6xl mx-auto">
      <PageContainer className="mt-2">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-900">Review Moderation</h1>
          <p className="text-gray-600 mt-2">
            Review and moderate flagged reviews from venue managers and the community.
          </p>
        </div>

        <ModerationQueue />
      </PageContainer>
    </div>
  );
};
